"use client";

import { IconDefinition, faAngleDown, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback, useMemo, useState } from "react";
import { useRecoilValue } from "recoil";

import { userStore } from "store/userStore";

const UserInfoMenu = ({
  menuList,
}: {
  menuList: { label: string; onClickMenuItem: () => void; onHoverMenuItem: () => void; icon: IconDefinition }[];
}) => {
  const [isOpened, setIsOpened] = useState(false);

  const onClick = useCallback((fn?: void) => {
    setIsOpened(false);
    fn;
  }, []);

  const user = useRecoilValue(userStore);

  const displayName = useMemo(() => {
    if (!user?.name) return user?.name;
    return user.name.length > 7 ? `${user.name.substring(0, 7)}...` : user.name;
  }, [user?.name]);

  return (
    <div
      className="relative ml-10 flex h-full min-w-[153px] items-center px-4 transition duration-300 hover:cursor-pointer hover:bg-neutral-50 hover:text-black"
      onClick={() => setIsOpened(!isOpened)}
      onBlur={() => setIsOpened(false)}
      role="button"
      tabIndex={0}
    >
      <div className="flex h-9 w-9 items-center justify-center rounded-full bg-neutral-100 text-neutral-500	">
        <FontAwesomeIcon icon={faUser} className="text-[17px]" />
      </div>
      <span className="ml-1 mr-auto flex flex-col text-s leading-normal">{displayName}</span>
      <div className="ml-1 flex h-[21px] w-[22px] items-center justify-center">
        <FontAwesomeIcon icon={faAngleDown} className="text-[12px] text-neutral-500" />
      </div>
      <div className="absolute left-0 top-[50%] h-[36px] w-[1px] translate-y-[-50%] bg-border"></div>
      <div
        className={`absolute left-0 top-[60px] z-20 w-full bg-white ${
          isOpened ? "flex flex-col" : "hidden"
        } rounded-b-[4px] shadow-md`}
      >
        {menuList.map(({ label, onClickMenuItem, icon, onHoverMenuItem }) => (
          <div
            key={label}
            className="flex h-[53px] cursor-pointer items-center border-t border-neutral-300 pl-4 text-s leading-normal  text-text-gray transition duration-300  hover:bg-neutral-100 hover:text-black"
            onClick={() => onClick(onClickMenuItem())}
            onMouseEnter={() => onHoverMenuItem()}
          >
            <FontAwesomeIcon icon={icon} className="mr-2 h-[13px] w-[13px]" />
            {label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default UserInfoMenu;
